export const isKnownExternalTool = (target: HTMLElement | null): boolean => {
  if (!target) {
    return false;
  }

  const tagName = target.tagName.toLowerCase();

  // ❗️ Generic checks only
  const isCustomElement = tagName.includes('-'); // matches things like <com-1password-button>, <bw-autofill>, etc.

  const isSensitiveAutoComplete = [
    'username',
    'email',
    'current-password',
    'new-password',
  ].includes(target.getAttribute('autocomplete') || '');

  const isExplicitOptOut =
    !!target.closest('[data-ignore-interact-outside]') ||
    !!target.closest('[data-password-manager]');

  const isInjectedIframe =
    tagName === 'iframe' ||
    !!target.closest('iframe[src*="password"]') || // Bitwarden, 1Password, etc.
    !!target.closest('iframe[src*="autofill"]');

  return (
    isSensitiveAutoComplete ||
    isCustomElement ||
    isInjectedIframe ||
    isExplicitOptOut
  );
};
